<template>

	<dashboard-plugin
			class="admin-dashboard-plugins-NotificationsResponseLineChart"
			name="Aantal reacties per periode"
			instruction="Ontdek trends met betrekking tot aantallen meldingen en de afhandeling daarvan."
			:loading="loading"
			:loadedFirstTime="loadedFirstTime"
			:hasData="hasData"
	>

		<v-select
			v-if="hasData"
			slot="headerRight"
			v-model="chosenTimespan"
			placeholder="Timespan"
			:options="timespanOptions"
			:reduce="timespan => timespan.value"

			:searchable="false"
			:clearable="false"

			@input="timespanInput"

			class="mt-4 ml-auto" 
		/>

		<Bar
			v-if="notificationResponseChart"
			:data="notificationResponseChart"
			:key="JSON.stringify(notificationResponseChart)"
			:height="100"
			:maintainAspectRatio="false"
			:responsive="false"
		/>


	</dashboard-plugin>

</template>

<script>

import BarChart from "./common/BarChart";
import Api from "../api";
import DashboardPlugin from "./common/DashboardPlugin";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import loader from "./mixins/loader";
import {filterStore} from "../filterStore";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import { Bar } from 'vue-chartjs'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export default {
	name: 'notifications-response-line-chart',
	mixins: [loader],
	
	components: {
		"v-select": vSelect,
		DashboardPlugin,
		Bar
	},

	data: function () {
		return {
			notificationResponseChart: null,
			chosenTimespan: 'week',

			chartOptions: {
				animation: {
					duration: 0 // general animation time
				},
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				responsiveAnimationDuration: 0, // animation duration after a resize

				// This options disables 'smoothing' the line
				line: {
					tension: 0 // disables bezier curves
				},
			},
		}
	},

	methods:
	{
		timespanInput(input)
		{
			this.updateChart()
		},

		updateHandler()
		{
			this.updateChart();
		},

		async updateChart()
		{
			if(!this.oneDaySelected && this.chosenTimespan == 'hour')
				this.chosenTimespan = 'day'

			this.incrementLoading()

			// Get the boilerplate for the chart. This needs to be a copy to trigger reactivity
			let boilerplate = Object.assign({}, this.chartBoilerplate)

			// Get the data to set on the boilerplate
			let notificationsArrays = await Api.getResponsesToNotifications({
				timespan: this.chosenTimespan
			})

			// todo high: slice arrays and show a particular sample of the data: otherwise chart.js cant render everything fast enough
			let timestamps = notificationsArrays['timestamps']
			let nullValues = notificationsArrays['null']
			let falseValues = notificationsArrays['false']
			let trueValues = notificationsArrays['true']

			// Set the timestamps as the labels
			boilerplate.labels = timestamps

			// Set the nullValues to the 'Genegeerd' line
			boilerplate['datasets'][0]['data'] = nullValues

			// Set the falseValues to the 'Geweigerd' line
			boilerplate['datasets'][1]['data'] = falseValues

			// Set the trueValues to the 'Geaccepteerd' line
			boilerplate['datasets'][2]['data'] = trueValues

			// Update the chart
			this.notificationResponseChart = boilerplate
			console.log( this.notificationResponseChart );

			this.decrementLoading()
		}
	},

	computed:
	{
		chartBoilerplate()
		{
			return {
				labels: [],
				datasets: [
					{
						label: 'Niet gereageerd',
						data: [],
						showLine: true,
						backgroundColor: 'rgb(239, 214, 19)',
						// borderColor: 'rgb(239, 214, 19)'
					},
					{
						label: 'Geweigerd',
						data: [],
						showLine: true,
						backgroundColor: 'rgba(255, 84, 84)',
						// borderColor: 'rgb(255, 84, 84)'
					},
					{
						label: 'Geaccepteerd',
						data: [],
						showLine: true,
						backgroundColor: 'rgba(61, 204, 91)',
						// borderColor: 'rgb(61, 204, 91)'
					},
				],

				options: this.chartOptions,
			}
		},

		oneDaySelected()
		{
			let startDate = filterStore.dateRange.startDate;
			let endDate = filterStore.dateRange.endDate;

			return startDate.toDateString() == endDate.toDateString()
		},

		timespanOptions()
		{
			let weekObject = {
				label: 'Per week',
				value: 'week'
			}

			let dayObject = {
				label: 'Per dag',
				value: 'day'
			}

			let hourObject = {
				label: 'Per uur',
				value: 'hour'
			}

			if(this.oneDaySelected)
				return [
					weekObject,
					dayObject,
					hourObject
				]
			else
				return [
					weekObject,
					dayObject,
				]
		},

		hasData()
		{
			let chartData = this.notificationResponseChart

			if(!chartData)
				return false;

			let datasets = chartData['datasets'];

			if(!datasets)
				return false;

			return datasets.some(dataset => {
				return dataset['data'].some(number => number > 0)
			});
		}
	},

	watch:
	{
		// 'notificationResponseChart'(newVal)
		// {
		// 	console.log(newVal)
		// }

	},
}

</script>

<style lang="scss">

	.admin-dashboard-plugins-NotificationsResponseLineChart {
		.v-select {
			width: 150px;

			ul {
				margin-top: -23px !important;
			}
		}
	}

</style>
